// extracted by mini-css-extract-plugin
export default {"closeIcon":"Modal_closeIcon__xDezy","closeIconWhite":"Modal_closeIconWhite__qMUof","animate":"Modal_animate__Ru1Hg","animateModalShow":"Modal_animateModalShow__CxfJ5"};